import type { DropdownOption } from '@/views/Community/views/CommunityListings/components/FilterButton/FilterDialog/LocationAutocomplete/LocationAutocomplete.helpers';
import { DEFAULT_LOCALE_IDS } from '../../../constants';

export const MAX_NUM_DROPDOWN_OPTIONS = 12;

export const buildDropdownOptions = (
  locationPredictions: DropdownOption[],
  teamNamePredictions: DropdownOption[],
  extraSlots = 0,
): DropdownOption[] => {
  const maxOptions = MAX_NUM_DROPDOWN_OPTIONS + extraSlots;
  const numberOfLocationOptions = locationPredictions.length;
  const numberOfNameOptions = teamNamePredictions.length;

  if (
    numberOfLocationOptions === 1 &&
    locationPredictions[0]?.label === 'No Results'
  ) {
    return numberOfNameOptions === 0 ? [] : teamNamePredictions;
  }

  if (numberOfLocationOptions < maxOptions / 2) {
    return [
      ...locationPredictions,
      ...teamNamePredictions.slice(0, maxOptions - numberOfLocationOptions),
    ];
  }

  if (numberOfNameOptions < maxOptions / 2) {
    return [
      ...locationPredictions.slice(0, maxOptions - numberOfNameOptions),
      ...teamNamePredictions,
    ];
  }

  return [
    ...locationPredictions.slice(0, maxOptions / 2),
    ...teamNamePredictions.slice(0, maxOptions / 2),
  ];
};

export function getResultType(resultId: string) {
  if (resultId.startsWith('team:')) {
    return 'search_team';
  }

  if (DEFAULT_LOCALE_IDS.includes(resultId)) {
    return resultId;
  }

  return 'search_location';
}
